import { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Card } from './ui/card';
import { Edit2, LogIn } from 'lucide-react';
import { useAuthStore } from '../store/authStore';
import { Link } from 'react-router-dom';

export function AnonymousUserSettings() {
  const { anonymousUser, updateAnonymousName, isAnonymous } = useAuthStore();
  const [isEditing, setIsEditing] = useState(false);
  const [nameInput, setNameInput] = useState(anonymousUser?.username || '');

  if (!isAnonymous || !anonymousUser) {
    return null;
  }

  const handleSave = () => {
    if (nameInput.trim().length >= 1 && nameInput.trim().length <= 100) {
      updateAnonymousName(nameInput.trim());
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setNameInput(anonymousUser.username);
    setIsEditing(false);
  };

  return (
    <Card className="p-3 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 flex-1">
          {isEditing ? (
            <>
              <Input
                value={nameInput}
                onChange={(e) => setNameInput(e.target.value)}
                placeholder="Enter your name"
                className="flex-1 max-w-xs"
                maxLength={100}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleSave();
                  } else if (e.key === 'Escape') {
                    handleCancel();
                  }
                }}
                autoFocus
              />
              <Button size="sm" onClick={handleSave} disabled={!nameInput.trim()}>
                Save
              </Button>
              <Button size="sm" variant="ghost" onClick={handleCancel}>
                Cancel
              </Button>
            </>
          ) : (
            <>
              <span className="text-sm text-muted-foreground">Chatting as:</span>
              <span className="font-medium">{anonymousUser.username}</span>
              <Button
                size="sm"
                variant="ghost"
                onClick={() => setIsEditing(true)}
                className="h-7"
              >
                <Edit2 className="w-3 h-3 mr-1" />
                Change Name
              </Button>
            </>
          )}
        </div>
        <Link to="/login">
          <Button size="sm" variant="outline">
            <LogIn className="w-3 h-3 mr-1" />
            Sign In
          </Button>
        </Link>
      </div>
    </Card>
  );
}

